// used for org level flags
export const WANDB_EMPLOYEES = 'wandb-employees';

export type FeatureKey = 'vega-panel' | 'workspace-optimizations';

export interface FeatureFlag {
  featureKey: FeatureKey; // unique id of the feature, e.g. 'vega-panel'
  enabledFor: string; //  entity name, project name, etc
}

type FeatureFlagData = {
  [featureKey in FeatureKey]: {[enabledFor: string]: 0 | 1};
};

// Feature Flags are enabled/disabled by W&B internally, typically for a whole entity.
// Note: This is different from Beta Features, which are experimental features that users can enable/disable on their settings page, and only affect that user.
// (See betaFeatures.ts and useBetaFeature.ts if that's what you're looking for.)

export const ALL_FEATURE_FLAGS: Readonly<FeatureFlagData> = {
  'vega-panel': {
    adrianbg: 1,
    adrnswanberg: 1,
    altay: 1,
    Angle: 1,
    angle: 1,
    axel: 1,
    blueriver: 1,
    carey: 1,
    csordas: 1,
    hamelsmu: 1,
    jeffr: 1,
    kylegoyette: 1, // Added 6/10/20 Kyle Goyette
    l2k2: 1,
    lavanya: 1,
    lavanyashukla: 1,
    'louis-wb': 1, // Added 4/11/20
    lshukla: 1,
    nbaryd: 1,
    sculpturearts: 1,
    shawn: 1,
    stacey: 1,
    syllogismos: 1,
    tom: 1,
    tri: 1,
    wandb: 1,
  },
  /**
   * Organization Flags
   * Note: there is a suble difference for feature flags that are used to control the presence of a beta toggle. Feature flags keyed by entity name work by controlling whether a feature is active or not in a route descended from that entity (e.g. `wandb.ai/myEntity/myProject`).
   *
   * Feature flags that controls whether a user can see a beta toggle check to see if a viewer is a member of an organization that the beta flag has been enabled for. The organization name may be, but IS NOT GUARANTEED TO BE, the same as the entity name of that organization.
   */
  'workspace-optimizations': {
    'Character Technologies, Inc.': 1, // character AI, entityName: character
    openai: 1,
    'Unity-Enterprise': 1, // Unity, entity names: deeppose, unity-labs-ai-research, generative-materials
    wandb: 1,
  },
};
